import { NotificationTypename } from "./types";

export const NOTIFICATIONS_BASE_ROUTE = "/notifications";

export const notificationsSlugs: Record<
	Exclude<NotificationTypename, "ConfirmIdentityDocumentDetailsNotification">,
	string
> = {
	VerifyAddressNotification: "verify-address",
	AddInvestingEntityNotification: "add-investing-entity",
	ProvideSourceOfFundsNotification: "provide-source-of-funds",
	VerifyIdentityNotification: "verify-identity",
	VerifyBiometricIdentityNotification: "verify-identity",
	ConfirmEmailAddressNotification: "confirm-email-address",
	ProvideBeneficialOwnerContactDetailsNotification:
		"provide-related-party-contact-details",
	ProvideCityOfBirthNotification: "provide-city-of-birth",
	ProvideInvestingEntityDocumentsNotification:
		"provide-investing-entity-documents",
	ReattemptVerifyBiometricIdentityNotification: "reattempt-verify-identity",
	ReattemptVerifyAddressNotification: "reattempt-verify-address",
	ReattemptProvideSourceOfFundsNotification:
		"reattempt-provide-source-of-funds",
	AddBankAccountNotification: "add-bank-account",
	VerifyNZDBankAccountNotification: "verify-bank-account-nzd",
	VerifyAUDBankAccountNotification: "verify-bank-account-aud",
	VerifyEURBankAccountNotification: "verify-bank-account-eur",
	VerifyGBPBankAccountNotification: "verify-bank-account-gbp",
	VerifyUSDBankAccountNotification: "verify-bank-account-usd",
	RenewAustralianAccreditationNotification: "renew-accreditation-au",
	RenewNewZealandAccreditationNotification: "renew-accreditation-nz",
	RenewAccreditationNotification: "renew-accreditation",
	ConfirmAustralianAccreditationNotification: "confirm-accreditation-au",
	ConfirmNewZealandAccreditationNotification: "confirm-accreditation-nz",
	ConfirmAccreditationNotification: "confirm-accreditation",
	ReattemptConfirmAccreditationNotification: "reattempt-accreditation",
	ConfirmUnsupportedCountryAccreditationNotification: "confirm-accreditation",
};

export const notificationsRoutes: Record<
	Exclude<NotificationTypename, "ConfirmIdentityDocumentDetailsNotification">,
	string
> = {
	VerifyAddressNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyAddressNotification}`,
	AddInvestingEntityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.AddInvestingEntityNotification}`,
	ProvideSourceOfFundsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideSourceOfFundsNotification}`,
	VerifyIdentityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyIdentityNotification}`,
	VerifyBiometricIdentityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyBiometricIdentityNotification}`,
	ConfirmEmailAddressNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmEmailAddressNotification}`,
	ProvideBeneficialOwnerContactDetailsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideBeneficialOwnerContactDetailsNotification}`,
	ProvideCityOfBirthNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideCityOfBirthNotification}`,
	ProvideInvestingEntityDocumentsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ProvideInvestingEntityDocumentsNotification}`,
	ReattemptVerifyBiometricIdentityNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptVerifyBiometricIdentityNotification}`,
	ReattemptVerifyAddressNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptVerifyAddressNotification}`,
	ReattemptProvideSourceOfFundsNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptProvideSourceOfFundsNotification}`,
	AddBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.AddBankAccountNotification}`,
	VerifyNZDBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyNZDBankAccountNotification}`,
	VerifyAUDBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyAUDBankAccountNotification}`,
	VerifyEURBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyEURBankAccountNotification}`,
	VerifyGBPBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyGBPBankAccountNotification}`,
	VerifyUSDBankAccountNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.VerifyUSDBankAccountNotification}`,
	RenewAustralianAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.RenewAustralianAccreditationNotification}`,
	RenewNewZealandAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.RenewNewZealandAccreditationNotification}`,
	RenewAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.RenewAccreditationNotification}`,
	ConfirmAustralianAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmAustralianAccreditationNotification}`,
	ConfirmNewZealandAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmNewZealandAccreditationNotification}`,
	ConfirmAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmAccreditationNotification}`,
	ReattemptConfirmAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ReattemptConfirmAccreditationNotification}`,
	ConfirmUnsupportedCountryAccreditationNotification: `${NOTIFICATIONS_BASE_ROUTE}/${notificationsSlugs.ConfirmAccreditationNotification}`,
};
